import UserDialogs from "../dialogs/users/userDialogs";

export const userConfig = {
  title: "User Management",
  columns: [
    { field: "name", headerName: "Name", type: "sort" },
    { field: "email", headerName: "Email Address", type: "sort" },
    { field: "createdDate", headerName: "Created Date" },
    { field: "latestLogin", headerName: "Latest Login", type: "latestLogin" },
    { field: "userType", headerName: "User Type", type: "userType" },
    { field: "createdBy", headerName: "Category", type: "createdBy" },
    {
      field: "accounts",
      headerName: "Accounts",
      type: "accounts",
      tooltipField: "accountNames",
    },
  ],
  dialogs: UserDialogs,
  createButtonText: "Create User",
  emptyMessage: "No users found",
};
